export default {
  // list
  'container_order.query.orderNo': 'orderNo',
  'container_order.query.orderNo.placeholder': 'Enter orderNo',
  'container_order.query.paymentMethod': 'settlementMethod',
  'container_order.query.paymentMethod.placeholder': 'Enter settlementMethod',
  'container_order.query.shippingTerms': 'shippingTerms',
  'container_order.query.shippingTerms.placeholder': 'Enter shippingTerms',
  'container_order.query.departureTime': 'departureTime',
  'container_order.query.departureTime.placeholder': 'Enter departureTime',
  'container_order.query.businessCategory': 'businessCategory',
  'container_order.query.businessCategory.placeholder': 'Enter businessCategory',
  'container_order.query.tradeMode': 'tradeMode',
  'container_order.query.tradeMode.placeholder': 'Enter tradeMode',
  'container_order.query.shiperId': 'shiperId',
  'container_order.query.shiperId.placeholder': 'Enter shiperId',
  'container_order.query.loadingPort': 'loadingPort',
  'container_order.query.loadingPort.placeholder': 'Enter loadingPort',
  'container_order.query.unloadingPort': 'unloadingPort',
  'container_order.query.unloadingPort.placeholder': 'Enter unloadingPort',
  'container_order.query.salesperson': 'salesperson',
  'container_order.query.salesperson.placeholder': 'Enter salesperson',
  'container_order.query.status': 'status',
  'container_order.query.status.placeholder': 'Enter status',
  'container_order.column.orderNo': 'orderNo',
  'container_order.column.paymentMethod': 'settlementMethod',
  'container_order.column.shippingTerms': 'shippingTerms',
  'container_order.column.departureTime': 'departureTime',
  'container_order.column.businessCategory': 'businessCategory',
  'container_order.column.tradeMode': 'tradeMode',
  'container_order.column.shiperId': 'shiperId',
  'container_order.column.contractId': 'contract',
  'container_order.column.loadingPoint': 'loadingPoint',
  'container_order.column.loadingPort': 'loadingPort',
  'container_order.column.loadingContactName': 'loadingContactName',
  'container_order.column.loadingContactPhone': 'loadingContactPhone',
  'container_order.column.unloadingPoint': 'unloadingPoint',
  'container_order.column.unloadingPort': 'unloadingPort',
  'container_order.column.unloadingContactName': 'unloadingContactName',
  'container_order.column.unloadingContactPhone': 'unloadingContactPhone',
  'container_order.column.salesperson': 'salesperson',
  'container_order.column.createBy': 'createBy',
  'container_order.column.updateBy': 'updateBy',
  'container_order.column.createTime': 'createTime',
  'container_order.column.updateTime': 'updateTime',
  'container_order.column.dataSource': 'dataSource',
  'container_order.column.remark': 'remark',
  'container_order.column.status': 'status',
  // edit
  'container_order.edit.title': 'Edit ContainerOrder',
  'container_order.add.title': 'Add ContainerOrder',
  'container_order.edit.success': 'Edit Successful',
  'container_order.add.success': 'Add Successful',
  'container_order.form.paymentMethod.required': 'settlementMethod cannot be null',
  'container_order.form.departureTime.required': 'departureTime cannot be null',
  'container_order.form.businessCategory.required': 'businessCategory cannot be null',
  'container_order.form.shiperId.required': 'shiperId cannot be null',
  'container_order.form.contractId.required': 'contractId cannot be null',
  'container_order.form.paymentMethod': 'settlementMethod',
  'container_order.form.paymentMethod.placeholder': 'Enter settlementMethod',
  'container_order.form.shippingTerms': 'shippingTerms',
  'container_order.form.shippingTerms.placeholder': 'Enter shippingTerms',
  'container_order.form.departureTime': 'departureTime',
  'container_order.form.departureTime.placeholder': 'Enter departureTime',
  'container_order.form.businessCategory': 'businessCategory',
  'container_order.form.businessCategory.placeholder': 'Enter businessCategory',
  'container_order.form.tradeMode': 'tradeMode',
  'container_order.form.tradeMode.placeholder': 'Enter tradeMode',
  'container_order.form.shiperId': 'shiperId',
  'container_order.form.shiperId.placeholder': 'Enter shiperId',
  'container_order.form.contractId': 'contract',
  'container_order.form.contractId.placeholder': 'Enter contractId',
  'container_order.form.loadingPoint': 'loadingPoint',
  'container_order.form.loadingPoint.placeholder': 'Enter loadingPoint',
  'container_order.form.loadingPort': 'loadingPort',
  'container_order.form.loadingPort.placeholder': 'Enter loadingPort',
  'container_order.form.loadingPortId': 'loadingPortId',
  'container_order.form.loadingPortId.placeholder': 'Enter loadingPortId',
  'container_order.form.loadingContactName': 'loadingContactName',
  'container_order.form.loadingContactName.placeholder': 'Enter loadingContactName',
  'container_order.form.loadingContactPhone': 'loadingContactPhone',
  'container_order.form.loadingContactPhone.placeholder': 'Enter loadingContactPhone',
  'container_order.form.unloadingPoint': 'unloadingPoint',
  'container_order.form.unloadingPoint.placeholder': 'Enter unloadingPoint',
  'container_order.form.unloadingPort': 'unloadingPort',
  'container_order.form.unloadingPort.placeholder': 'Enter unloadingPort',
  'container_order.form.unloadingPortId': 'unloadingPortId',
  'container_order.form.unloadingPortId.placeholder': 'Enter unloadingPortId',
  'container_order.form.unloadingContactName': 'unloadingContactName',
  'container_order.form.unloadingContactName.placeholder': 'Enter unloadingContactName',
  'container_order.form.unloadingContactPhone': 'unloadingContactPhone',
  'container_order.form.unloadingContactPhone.placeholder': 'Enter unloadingContactPhone',
  'container_order.form.salesperson': 'salesperson',
  'container_order.form.salesperson.placeholder': 'Enter salesperson',
}
